import { Expert, ExpertiseAndSkills, ListItem } from '../../../../store/signUp/types';
import { setExperties, setSignUpStep } from '../../../../store/signUp/slice';
import { useDispatch, useSelector } from '../../../../store/store';
import MotionWrapper from '../../../../containers/MotionWrapper';
import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import Tag from '../../../../components/Tag';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    selectEditMode,
    selectExperties,
    selectExpertsList,
    selectSkillsList,
} from '../../../../store/signUp/selectors';
import {
    getSkillsThunk,
    getExpertiesThunk,
} from '../../../../store/signUp/thunks';

const defaultExpert = { id: -1, title: '', orderId: 0 };

function Expertise() {
    const editMode = useSelector(selectEditMode);
    const experties = useSelector(selectExperties);
    const skillsList = useSelector(selectSkillsList);
    const [skill1Title, setSkill1Title] = useState('');
    const [skill2Title, setSkill2Title] = useState('');
    const [skill3Title, setSkill3Title] = useState('');
    const expertsList = useSelector(selectExpertsList);
    const [customSkillIndx, setCustomSkillIndx] = useState(-1);
    const [skills1, setSkills1] = useState<ListItem[]>(experties[0]?.skills || []);
    const [skills2, setSkills2] = useState<ListItem[]>(experties[1]?.skills || []);
    const [skills3, setSkills3] = useState<ListItem[]>(experties[2]?.skills || []);
    const [expert1, setExpert1] = useState<Expert>(experties[0]?.expert || defaultExpert);
    const [expert2, setExpert2] = useState<Expert>(experties[1]?.expert || defaultExpert);
    const [expert3, setExpert3] = useState<Expert>(experties[2]?.expert || defaultExpert);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getExpertiesThunk());
        dispatch(getSkillsThunk());
    }, []);

    const addSkill = (expert: number, item: ListItem) => {
        setCustomSkillIndx(prev => prev - 1);

        switch (expert) {
            case 0: {
                const list = [...skills1, item].sort((a, b) => a.title.length - b.title.length);
                setSkills1([...new Set(list)]);
                setSkill1Title('');
                break;
            }
            case 1: {
                const list = [...skills2, item].sort((a, b) => a.title.length - b.title.length);
                setSkills2([...new Set(list)]);
                setSkill2Title('');
                break;
            }
            case 2: {
                const list = [...skills3, item].sort((a, b) => a.title.length - b.title.length);
                setSkills3([...new Set(list)]);
                setSkill3Title('');
                break;
            }
            default:
                return;
        }
    };

    const removeSkill = (expert: number, id: number) => {
        switch (expert) {
            case 0:
                setSkills1(prev => prev.filter(i => i.id !== id));
                break;
            case 1:
                setSkills2(prev => prev.filter(i => i.id !== id));
                break;
            case 2:
                setSkills3(prev => prev.filter(i => i.id !== id));
                break;
            default:
                return;
        }
    };

    const next = () => {
        const formData: ExpertiseAndSkills[] = [];
        expert1.title && formData.push({ expert: expert1, skills: skills1 });
        expert2.title && formData.push({ expert: expert2, skills: skills2 });
        expert3.title && formData.push({ expert: expert3, skills: skills3 });

        dispatch(setExperties(formData));
        dispatch(setSignUpStep(editMode ? 'reviewInfo' : 'uploadFiles'));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.expert}>
                <Input
                    listShow
                    label='1.Your first preferred fields of employment:'
                    isRequired
                    type='text'
                    listIdKey='id'
                    listTitleKey='title'
                    value={expert1.title}
                    placeholder='EX-1: Software engineer'
                    onItemClick={(item: Expert) => setExpert1(item)}
                    onChange={(val: string) => setExpert1({ id: -1, title: val, orderId: 0 })}
                    list={expertsList.filter(i => i.title.toLowerCase().startsWith(expert1.title.toLowerCase()))}
                />
                <div className={styles.expert_skills}>
                    <div className={styles.expert_skills_action}>
                        <Input
                            listShow
                            type='text'
                            listIdKey='id'
                            label='Your related skills:'
                            isRequired
                            value={skill1Title}
                            listTitleKey='title'
                            onChange={setSkill1Title}
                            placeholder='Enter skill or select from list'
                            wrapperClassName={styles.expert_skills_action_input}
                            onItemClick={(item: ListItem) => addSkill(0, item)}
                            list={skillsList.filter(i => i.title.toLowerCase().startsWith(skill1Title.toLowerCase()))}
                        />
                        <Button
                            text='+'
                            type='Primary'
                            disabled={!skill1Title}
                            onClick={() => addSkill(0, { id: customSkillIndx, title: skill1Title })}
                        />
                    </div>
                    {skills1.length > 0 && <div className={styles.expert_skills_box}>
                        {skills1.map(item => <Tag
                            key={item.id}
                            title={item.title}
                            action={() => removeSkill(0, item.id)}
                        />)}
                    </div>}
                </div>
            </div>

            <div className={styles.expert}>
                <Input
                    listShow
                    type='text'
                    label='2.Your second preferred fields of employment:'
                    listIdKey='id'
                    listTitleKey='title'
                    value={expert2.title}
                    placeholder='EX-2: Data scientist (Optional)'
                    onItemClick={(item: Expert) => setExpert2(item)}
                    onChange={(val: string) => setExpert2({ id: -1, title: val, orderId: 1 })}
                    list={expertsList.filter(i => i.title.toLowerCase().startsWith(expert2.title.toLowerCase()))}
                />
                <div className={styles.expert_skills}>
                    <div className={styles.expert_skills_action}>
                        <Input
                            listShow
                            type='text'
                            listIdKey='id'
                            label='Your related skills:'
                            value={skill2Title}
                            listTitleKey='title'
                            onChange={setSkill2Title}
                            placeholder='Enter skill or select from list'
                            wrapperClassName={styles.expert_skills_action_input}
                            onItemClick={(item: ListItem) => addSkill(1, item)}
                            list={skillsList.filter(i => i.title.toLowerCase().startsWith(skill2Title.toLowerCase()))}
                        />
                        <Button
                            text='+'
                            type='Primary'
                            disabled={!skill2Title}
                            onClick={() => addSkill(1, { id: customSkillIndx, title: skill2Title })}
                        />
                    </div>
                    {skills2.length > 0 && <div className={styles.expert_skills_box}>
                        {skills2.map(item => <Tag
                            key={item.id}
                            title={item.title}
                            action={() => removeSkill(1, item.id)}
                        />)}
                    </div>}
                </div>
            </div>

            <div className={styles.expert}>
                <Input
                    listShow
                    type='text'
                    listIdKey='id'
                    label='3.Your third preferred fields of employment:'
                    listTitleKey='title'
                    value={expert3.title}
                    onItemClick={(item: Expert) => setExpert3(item)}
                    placeholder='EX-3: Cyber security engineer (Optional)'
                    onChange={(val: string) => setExpert3({ id: -1, title: val, orderId: 2 })}
                    list={expertsList.filter(i => i.title.toLowerCase().startsWith(expert3.title.toLowerCase()))}
                />
                <div className={styles.expert_skills}>
                    <div className={styles.expert_skills_action}>
                        <Input
                            listShow
                            type='text'
                            listIdKey='id'
                            label='Your related skills:'
                            value={skill3Title}
                            listTitleKey='title'
                            onChange={setSkill3Title}
                            placeholder='Enter skill or select from list'
                            wrapperClassName={styles.expert_skills_action_input}
                            onItemClick={(item: ListItem) => addSkill(2, item)}
                            list={skillsList.filter(i => i.title.toLowerCase().startsWith(skill3Title.toLowerCase()))}
                        />
                        <Button
                            text='+'
                            type='Primary'
                            disabled={!skill3Title}
                            onClick={() => addSkill(2, { id: customSkillIndx, title: skill3Title })}
                        />
                    </div>
                    {skills3.length > 0 && <div className={styles.expert_skills_box}>
                        {skills3.map(item => <Tag
                            key={item.id}
                            title={item.title}
                            action={() => removeSkill(2, item.id)}
                        />)}
                    </div>}
                </div>
            </div>
            <div className={styles.actions}>
                <Button
                    size='sm'
                    text='Back'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setSignUpStep('education'))}
                />
                <Button
                    size='sm'
                    type='Primary'
                    onClick={next}
                    className={styles.actions_btn}
                    text={editMode ? 'Save' : 'Continue'}
                    disabled={!expert1.title || (skills1.length === 0)}
                />
            </div>
        </MotionWrapper>
    );
};

export default Expertise;
